import { h, JSX } from "@stencil/core";
import { navContentStore } from "@phn/state/nav-content-store";
import { navStateStore } from "@phn/state/nav-state-store";
import { isString } from "../../../../shared/utility/helper";
import { routerStore } from "../../../../shared/state/router-store";

export const MainDrawerContent = ({
  activeRoutingKey,
  locale,
  backButtonText,
  onClickBack,
  receivedContent,
  modelType,
}: {
  activeRoutingKey: string;
  locale: string;
  backButtonText: string;
  onClickBack: () => void;
  receivedContent: boolean;
  modelType: string;
}): JSX.Element => (
  <div class="drawer-content">
    <div class="main-drawer-header">
      {isString(backButtonText) ? (
        <phn-nd-back-button
          class="back-button"
          onClick={() => {
            delete navStateStore.state.modelType;
            onClickBack();
          }}
          text={backButtonText}
          analyticsId={navContentStore.state.menu.id}
        />
      ) : null}
    </div>

    <phn-nd-router
      activeRoutingKey={activeRoutingKey}
      breakpoint={routerStore.state.breakpoint}
      locale={locale}
      receivedContent={receivedContent}
      modelType={modelType}
    />
  </div>
);
